<template>
  <transition :name="modal">
    <div v-show="winVisible" class="window__wrapper" :style="windowWrapperStyle" @click="wrapperClick">
      <div class="window" :class="fullscreen ? 'is-fullscreen' : ''" :style="windowStyle" @click.stop>
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Window',
  components: {
  },
  props: {
    winVisible: {
      type: Boolean,
      default: false
    },
    modal: {
      type: String,
      default: 'modal'
    },
    width: {
      type: String,
      default: '800px'
    },
    height: {
      type: String,
      default: '600px'
    },
    margin: {
      type: String,
      default: '15vh auto 50px'
    },
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    wrapperClosable: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    windowStyle () {
      return {
        width: this.width,
        height: this.height,
        margin: this.margin
      }
    },
    windowWrapperStyle () {
      return {
        position: this.modalAppendToBody ? 'fixed' : 'absolute',
        pointerEvents: this.wrapperClosable ? 'auto' : 'none'
      }
    }
  },
  watch: {
  },
  methods: {
    wrapperClick () {
      this.$emit('wrapperClick')
    }
  }
}
</script>

<style lang="stylus" scoped>
  .window__wrapper {
    //position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    z-index: 99;
    //pointer-events: none;
  }
  .window {
    position: relative;
    //width: 800px;
    //height: 600px;
    overflow: auto;
    //pointer-events: auto;
    user-select: none;
    //margin: 15vh auto 50px;
    //left: 50%;
    //top: 28px;
    border: 1px solid rgba(0,0,0,.05);
    box-shadow: 1px 1px 50px rgba(0,0,0,.3);
    background-color: #f3f3f3;
    border-radius: 10px;
    pointer-events: auto;
    //transform: translate(-50%);
  }
  .is-fullscreen {
    width: 100% !important;
    height: 100% !important;
    top: 0 !important;
    left: 0 !important;
    margin: 0 !important;
  }
  .modal-enter-active, .modal-leave-active {
    transition: opacity 0.5s ease, transform 0.5s ease;
  }
  .modal-enter, .modal-leave-to {
    opacity: 0;
    transform: translate(0, 0) scale(0.1);
  }
  .modal-slide-left-enter-active, .modal-slide-left-leave-active {
    transition: transform 0.8s ease;
  }
  .modal-slide-left-enter, .modal-slide-left-leave-to {
    transform: translateX(100%);
  }
</style>



// WEBPACK FOOTER //
// src/common/im/Window.vue